import React, { useState } from "react";
import menu from "../assets/menu.svg";
import close from "../assets/close.svg";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";
import Circles from "./Circles";
import Rules from "./../pages/rules";
import { useModal } from "./../providers/ModalContext";

function Nav() {
  const { openModal } = useModal();
  const [isOpen, setIsOpen] = useState(false);

  if (isOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "unset";
  }

  return (
    <>
      <div className="w-full z-40 height-[100%]">
        <div
          className="z-30 relative ml-auto h-6 w-6 cursor-pointer"
          onClick={handleClick}
        >
          {isOpen ? (
            <img src={close} className="close-icon" alt="close menu" />
          ) : (
            <img src={menu} className="menu-icon" alt="menu" />
          )}
        </div>
        {isOpen && (
          <div className={`${isOpen ? "active" : ""}`}>
            <ul className="list-none">
              <li>
                <Link
                  to="/"
                  reloadDocument={true}
                  className="text-white font-bold text-2xl leading-loose no-underline"
                >
                  Start
                </Link>
              </li>
              <li>
                <Link
                  to="/topplistan"
                  className="text-white font-bold text-2xl leading-loose no-underline"
                >
                  Topplistan
                </Link>
              </li>
              <li className="text-white font-bold text-2xl leading-loose no-underline cursor-pointer" onClick={() => { openModal('Rules');  }}>

                Tävlingsregler
              </li>
              <li  className="text-white font-bold text-2xl leading-loose no-underline cursor-pointer" onClick={() => { openModal('Conditions'); }}>

                Tävlingsvillkor
              </li>
              <li  className="text-white font-bold text-2xl leading-loose no-underline cursor-pointer" onClick={() => { openModal('Gdpr'); }}>
                GDPR
              </li>

              <li className="mt-[104px]">
                <a
                  href="https://www.frolundatorg.se"
                  className="text-white font-bold text-2xl leading-loose no-underline"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.frolundatorg.se
                </a>
              </li>
            </ul>
            <div className="bottom-[30px]">
              <img src={logo} alt="logo" />
            </div>
          </div>
        )}
      </div>
    </>
  );

  function handleClick() {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  }
}

export default Nav;
